import React, { FC, useEffect, useState } from 'react'
import useScrollDirection from 'hooks/scrollDirection'
import SeoContentConnector, { ConnectorProps as SeoContentProps } from '../connectors/SeoContent'
import FilterButton from '../components/header/FilterButton'
import HeaderTitle from '../components/header/HeaderTitle'
import styles from './Browse.module.scss'
import useIsMobile from 'hooks/useIsMobile'
import classNames from 'classnames'
import TileList from '../components/recommendationTiles/TilesList'

type BrowserHeaderProps = SeoContentProps & {
  onOpenMobileFilter: () => void
  isFiltersVisible: boolean
}

const BrowserHeader: FC<BrowserHeaderProps> = ({
  onOpenMobileFilter,
  isFiltersVisible,
  urlPath,
}) => {
  const { scrollDir } = useScrollDirection()
  const isMobileScreen = useIsMobile()
  const [showStickyFilters, setShowStickyFilters] = useState(false)

  const handleToggleFilters = () => {
    onOpenMobileFilter()
  }

  const validPathToShowRecommendedTiles = /^(\/all)$/
  useEffect(() => {
    const scrollEvent = () => {
      const windowHeight = window.innerHeight
      const pageHeight = window.document.body.offsetHeight
      const { scrollY } = window
      // find if the user has scrolled more than 25% of the page
      // if yes, show sticky filters when user scrolls up
      const threshold = 0.1 * (pageHeight || 1500)
      // find if user has reached the footer section
      // if yes, don't show sticky filters when scroll up
      const footerThreshold = pageHeight - 0.12 * pageHeight

      if (scrollY > threshold && windowHeight + scrollY < footerThreshold) {
        setShowStickyFilters(true)
      } else {
        setShowStickyFilters(false)
      }
    }

    window.addEventListener('scroll', scrollEvent)
    return () => {
      window.removeEventListener('scroll', scrollEvent)
    }
  }, [showStickyFilters])

  return (
    <div className={styles.browseHeaderContainer}>
      <HeaderTitle />
      {validPathToShowRecommendedTiles.test(urlPath) ? <TileList /> : ''}
      <div className={styles.headerButtonFilters}>
        {isMobileScreen && (
          <div
            className={classNames({
              [styles.headerButtonFiltersSticky]: showStickyFilters && scrollDir === 'up',
              [styles.headerButtonFiltersHideSticky]: showStickyFilters && scrollDir !== 'up',
            })}
          >
            <FilterButton
              onClickFilterButton={handleToggleFilters}
              isFiltersVisible={isFiltersVisible}
            />
          </div>
        )}
      </div>
    </div>
  )
}

export default SeoContentConnector(BrowserHeader)
